<template>
  <div class="insurance-samlino" v-if="hasData">
    <a
      class="insurance-samlino__link"
      @click="trigger"
      :href="landingPage"
      target="_blank"
    >
      <div>
        Forsikring fra
        {{ thousandSeparator(price) }}
        kr./md.
      </div>
      <img
        src="@/assets/samlinoLogo.svg"
        alt="Samlino"
        loading="lazy"
        class="insurance-samlino__logo"
      />
    </a>
  </div>
</template>

<script>
import axios from 'axios'
import {
  LogWidgetShownInsuranceSamlino,
  LogWidgetInitiateApplicationInsuranceSamlino,
} from '@/events'
import { thousandSeparator } from '@/functions'
import { logErrorSamlino } from '@/errorHandler'

export default {
  name: 'InsuranceSamlino',
  components: {},
  props: {
    adId: { default: '', type: String },
    url1: { default: '', type: String },
    url2: { default: '', type: String },
    url3: { default: '', type: String },
    landingPage: { default: '', type: String },
  },
  data() {
    return {
      price: '',
      hasData: false,
      showPixel: false,
    }
  },
  methods: {
    thousandSeparator(value) {
      return thousandSeparator(value)
    },
    formatComma(str) {
      return str.toString().replace('.', ',')
    },
    removeDecimals(str) {
      return str.toFixed()
    },
    init() {
      this.calculate()
    },
    async calculate() {
      const urls = [this.url1, this.url2, this.url3]

      const processResponse = response => {
        if (response?.data.lowest_monhtly_price) {
          this.price = this.removeDecimals(response.data.lowest_monhtly_price)
          this.hasData = true
          LogWidgetShownInsuranceSamlino()
          return true
        }
        return false
      }

      const handleError = error => {
        const samlinoError = {
          adId: this.adId,
          url1: this.url1,
          url2: this.url2,
          url3: this.url3,
          errorMessage: error.message,
          response: error,
        }
        logErrorSamlino(samlinoError)
      }

      for (let i = 0; i < urls.length; i++) {
        const url = urls[i]
        try {
          const response = await axios.get(url)
          if (i < urls.length - 1) {
            if (processResponse(response)) {
              return
            }
          } else {
            if (!processResponse(response)) {
              handleError(
                {
                  message: response.data.message,
                  response: response.data,
                },
                url
              )
            }
          }
        } catch (error) {
          handleError(error)
        }
      }
    },
    trigger() {
      LogWidgetInitiateApplicationInsuranceSamlino()
    },
  },
  created() {
    this.init()
  },
  mounted() {
    // if cookie accepted
    if (window.CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
      this.showPixel = true
    }
  },
}
</script>

<style lang="scss">
@import 'InsuranceSamlino.scss';
</style>
